import { render, staticRenderFns } from "./UnidadeParceira.vue?vue&type=template&id=1a50572c"
import script from "./UnidadeParceira.vue?vue&type=script&lang=js"
export * from "./UnidadeParceira.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports